import { createFileRoute } from '@tanstack/react-router';
import PageWrapper from 'src/components/PageWrapper/PageWrapper';

export const Route = createFileRoute('/user/login')({
  component: RouteComponent
});

function RouteComponent() {
  return (
    <PageWrapper title="Log in" description="Log in to access your account">
      <div>Hello "/user/login"!</div>
    </PageWrapper>
  );
}
